import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '../src/assets/styles/main.css';
import '../src/assets/styles/spacing.css';
import '../src/assets/styles/Responsive.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Aos from 'aos';
import 'aos/dist/aos.css';
import { BrowserRouter as Router, Routes } from 'react-router-dom';
import { useEffect } from 'react';
import Navbar from './components/common/Navbar';
import Footer from './components/common/Footer';
import AllRoutes from './AllRoutes';
import { axiosInstance } from './components/pages/config';
import secureLocalStorage from 'react-secure-storage';
import ServicesContextProvider from './components/Reusable/ServiceContext';
function App() {
  useEffect(() => {
    Aos.init({
      offset: 100, // offset (in px) from the original trigger point
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: 'ease-out',
      once: false,
    });
  }, []);

  return (
    <ServicesContextProvider>
      <div className="App">
        <Router>
          <Navbar />
          <AllRoutes />
          <Footer />
        </Router>
      </div>
    </ServicesContextProvider>
  );
}

export default App;
